import React, { useEffect, useState } from 'react';
import './ReadMe.scss';
import content from './intro.md';

function ReadMe(): React.ReactElement {
  return (
    <div
      className="px-5 readme-container"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}

export default ReadMe;
